import { NgIf } from '@angular/common';
import { Component, input } from '@angular/core';
import { LimitedCurrencyAmount } from '@lx/currency/shared/model/currency.model';
import { Amount } from '@lx/shared/data-access/types';
import { EqualPipe, PricePipe } from '@lx/shared/ui/pipes';

@Component({
  standalone: true,
  selector: 'lx-quote-breakdown-section',
  templateUrl: './quote-breakdown-section.component.html',
  styleUrls: ['./quote-breakdown-section.component.scss'],
  imports: [EqualPipe, NgIf, PricePipe],
})
export class QuoteBreakdownSectionComponent {
  price = input<Amount[]>();
  endPrice = input<LimitedCurrencyAmount[]>();
  currency = input<string | undefined>();
}
